import angular from 'angular';

/**
 * Controla el grid de incidencias.
 */
IncidenciasGridCtrl.$inject = ['$log', '$scope', 'dialogService', '$http', 'IncidenciaActionsService'];
export default function IncidenciasGridCtrl($log, $scope, dialogService, $http, IncidenciaActionsService) {
    var TAG = 'IncidenciasGridCtrl: ';

    $scope.modeloPrioridad = 1;
    $scope.modeloPrioridad2 = 1;
    $scope.opcionesPrioridad = [
        {
            label: 'p1',
            value: 0
        },
        {
            label: 'p2',
            value: 1
        }
    ];

    var DIALOG_RELACIONAR_TEMPLATE = require('./relacionar/relacionarIncidenciaDialog.html');
    var DIALOG_RELACIONAR_ID = 'dialog_relacionarIncidencia';
    var DIALOG_DUPLICADA_TEMPLATE = require('./incidenciaDuplicadaDialog.html');
    var DIALOG_DUPLICADA_ID = 'dialogDuplicadaIncidencia';

    $scope.editarOrigenOExpediente = function (incidenciaId, tareaId, tipo) {
        IncidenciaActionsService.editarOrigenOExpediente(incidenciaId, tareaId, tipo);
    };

    $scope.relacionarIncidencia = function (incidenciaId) {
        var titulo = ucfirst(Lang.choice('nombres.relacionar', 1)) + ' ' + Lang.choice('nombres.incidencia', 1);

        var opcionesExtra = {
            botonOk: ucfirst(Lang.choice('nombres.aceptar', 1)),
            botonCancel: ucfirst(Lang.get('nombres.cancelar')),
            validate: function (model) {
                if (!(issetAndNotEmpty(model) && angular.isDefined(model.tarea) && angular.isObject(model.tarea))) {
                    Sigo.UI.Messages.open([Lang.get('mensajes.no_selec_inci')], false);
                    return false;
                }
                return true;
            }
        };

        var opciones = {
            title: titulo
        };

        dialogService.open(DIALOG_RELACIONAR_ID, DIALOG_RELACIONAR_TEMPLATE, {id: incidenciaId}, opciones, opcionesExtra)
            .then(function (model) {
                $http.post(Sigo.var.path + '/incidencias/relacionar-incidencia/' + model.id + '/' + model.tarea.originalObject.codigo,
                    {tipo: model.motivo, descripcion: model.descripcion})
                    .success(function (data) {
                        Sigo.UI.Messages.open(data.messages, 0);
                        actualizaFilaVIncidencia(data.vIncidencia);
                    }).error(function (data) {
                    Sigo.UI.Messages.open([data.error.message], 0);
                });
            });
    };

    $scope.duplicadaIncidencia = function (incidenciaId) {
        $log.debug('Marcando como duplicada la incidencia ' + incidenciaId + ' ...');

        $http.get(Sigo.var.path + '/incidencias/duplicada/' + incidenciaId)
            .success(function (data) {
                var opcionesExtra = {
                    botonOk: ucfirst(Lang.get('estados.duplicada')),
                    botonCancel: ucfirst(Lang.get('nombres.cancelar'))
                };
                var opciones = {
                    title: Lang.get('mensajes.confirmacion_duplicada')
                };

                dialogService.open(DIALOG_DUPLICADA_ID, DIALOG_DUPLICADA_TEMPLATE, data, opciones, opcionesExtra)
                    .then(function () {
                        $http.post(Sigo.var.path + '/incidencias/duplicada/' + incidenciaId, {codigo: incidenciaId})
                            .success(function (data) {
                                Sigo.UI.Messages.open(data.messages, 0);
                                actualizaFilaVIncidencia(data.vIncidencia);
                            })
                            .error(function (data) {
                                Sigo.UI.Messages.open(data.messages, 0);
                            });
                    })
            })
            .error(function (data) {
                Sigo.UI.Messages.open([data.error.message], 0);
            });
    };
}